/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationDetailsAboutBox_ViewerOrganisationFragment = { __typename: 'ViewerOrganisation', id: string, description: string, organisationType: Types.OrganisationType, industry?: string | null, about?: any | null, yearFounded?: number | null, employeesNumber?: number | null };

export type OrganisationDetailsAboutBox_ModifyOrganisationMutationVariables = Types.Exact<{
  input: Types.OrganisationUpdateInput;
}>;


export type OrganisationDetailsAboutBox_ModifyOrganisationMutation = { updateOrganisation: { __typename: 'OrganisationUpdateResult', organisation: { __typename: 'ViewerOrganisation', id: string, description: string, organisationType: Types.OrganisationType, industry?: string | null, about?: any | null, yearFounded?: number | null, employeesNumber?: number | null } } };

export const OrganisationDetailsAboutBox_ViewerOrganisationFragmentDoc = gql`
    fragment OrganisationDetailsAboutBox_ViewerOrganisation on ViewerOrganisation {
  id
  description
  organisationType
  industry
  about
  yearFounded
  employeesNumber
}
    `;
export const OrganisationDetailsAboutBox_ModifyOrganisationDocument = gql`
    mutation OrganisationDetailsAboutBox_ModifyOrganisation($input: OrganisationUpdateInput!) {
  updateOrganisation(input: $input) {
    organisation {
      id
      description
      organisationType
      industry
      about
      yearFounded
      employeesNumber
    }
  }
}
    `;
export type OrganisationDetailsAboutBox_ModifyOrganisationMutationFn = Apollo.MutationFunction<OrganisationDetailsAboutBox_ModifyOrganisationMutation, OrganisationDetailsAboutBox_ModifyOrganisationMutationVariables>;

/**
 * __useOrganisationDetailsAboutBox_ModifyOrganisationMutation__
 *
 * To run a mutation, you first call `useOrganisationDetailsAboutBox_ModifyOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDetailsAboutBox_ModifyOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationDetailsAboutBoxModifyOrganisationMutation, { data, loading, error }] = useOrganisationDetailsAboutBox_ModifyOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationDetailsAboutBox_ModifyOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationDetailsAboutBox_ModifyOrganisationMutation, OrganisationDetailsAboutBox_ModifyOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationDetailsAboutBox_ModifyOrganisationMutation, OrganisationDetailsAboutBox_ModifyOrganisationMutationVariables>(OrganisationDetailsAboutBox_ModifyOrganisationDocument, options);
      }
export type OrganisationDetailsAboutBox_ModifyOrganisationMutationHookResult = ReturnType<typeof useOrganisationDetailsAboutBox_ModifyOrganisationMutation>;
export type OrganisationDetailsAboutBox_ModifyOrganisationMutationResult = Apollo.MutationResult<OrganisationDetailsAboutBox_ModifyOrganisationMutation>;
export type OrganisationDetailsAboutBox_ModifyOrganisationMutationOptions = Apollo.BaseMutationOptions<OrganisationDetailsAboutBox_ModifyOrganisationMutation, OrganisationDetailsAboutBox_ModifyOrganisationMutationVariables>;